const QuizzesActionType = {
  FETCH_ALL_QUIZZES: "FETCH_ALL_QUIZZES",
  FETCH_SINGLE_QUIZ: "FETCH_SINGLE_QUIZ",
  ADD_QUIZ: "ADD_QUIZ",
  EDIT_QUIZ: "EDIT_QUIZ",
  DELETE_QUIZ: "DELETE_QUIZ",
  COMPLETE_QUIZ: "COMPLETE_QUIZ"
};
export default QuizzesActionType;